<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-[#D4D7DE] dark:bg-[#3333331f] bg-opacity-75 transition-opacity backdrop-blur-sm"></div>
    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class="fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <div class="w-screen max-w-2xl px-2 py-2 bg-white dark:bg-zinc-950 h-screen overflow-scroll">
                    <form [formGroup]="relationlegForm" (ngSubmit)="createBLeg()" class="mt-4 px-4">

                        <div class="flex justify-between items-center">
                            <h2 class="heading">Create Relation Leg</h2>
                            <button type="button" (click)="onCloseModal()"
                                class="rounded-lg p-1 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
                                <span class="sr-only">Close panel</span>
                                <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

                        <!-- Pickup -->
                        <div formGroupName="pickup">
                            <div class="mt-4">
                                <h3 class="text-lg font-medium leading-6 text-xs-dark">Pickup</h3>
                            </div>
                            <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                                <div
                                    class="sm:col-span-6 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg">
                                    <div class="grid grid-cols-1 gap-2 sm:grid-cols-6">
                                        <div class="col-span-full grid grid-cols-1 gap-2 sm:grid-cols-6">

                                            <div class="sm:col-span-3">
                                                <div class="flex items-center justify-between">
                                                    <label
                                                        class="block text-sm font-medium text-main-secondary">Time</label>
                                                    <div
                                                        class="flex items-center space-x-2 border border-dashed border-zinc-200 dark:border-white/5 bg-zinc-950/5 dark:bg-white/5 px-2 py-0.5 rounded">
                                                        <input type="checkbox"
                                                            class="h-4 w-4 accent-main-base cursor-pointer"
                                                            id="pickupWillCall" [(ngModel)]="isWillCallPickup"
                                                            (change)="setWillCall($event, -1)"
                                                            [ngModelOptions]="{ standalone: true }" />
                                                        <label for="pickupWillCall"
                                                            class="text-xs cursor-pointer select-none">Will Call</label>
                                                    </div>
                                                </div>
                                                <div class="mt-1 relative">
                                                    <input type="text" name="pickupTime" id="pickupTime"
                                                        formControlName="time" [owlDateTime]="dtPickUpTime"
                                                        [owlDateTimeTrigger]="dtPickUpTime"
                                                        [disabled]="isWillCallPickup" />
                                                    <div
                                                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            class="h-5 w-5 text-xs-light" viewBox="0 0 24 24">
                                                            <g fill="none" stroke="currentColor" stroke-linecap="round"
                                                                stroke-linejoin="round" stroke-width="2">
                                                                <path
                                                                    d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                                                                <path
                                                                    d="M14 18a4 4 0 1 0 8 0a4 4 0 1 0-8 0m1-15v4M7 3v4m-4 4h16" />
                                                                <path d="M18 16.496V18l1 1" />
                                                            </g>
                                                        </svg>
                                                    </div>
                                                </div>
                                                <owl-date-time [disabled]="isWillCallPickup"
                                                    (afterPickerClosed)="onPickupTimeChange()" #dtPickUpTime>
                                                </owl-date-time>
                                            </div>

                                            <div class="sm:col-span-3" formGroupName="address">
                                                <label
                                                    class="block text-sm font-medium text-main-secondary">Address</label>
                                                <div class="mt-1">
                                                    <input type="text" formControlName="name" class="dark:bg-white/5" placeholder="Enter the address" googlePlace
                                                        (onSelect)="setPickupAddress($event)" (input)="onChangePickupAddress()" />
                                                </div>
                                            <div class="error" *ngIf="submitted">
                                                <p *ngIf="relationlegForm.get('pickup.address.name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                                    Address is required
                                                </p>
                                                <p *ngIf="relationlegForm.get('pickup.address')?.errors?.invalidAddress" class="mt-2 text-red-600 text-xs">
                                                    Invalid address (select from the dropdown)
                                                </p>
                                            </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Dropoff -->
                        <div formGroupName="destination" class="mt-6">
                            <div class="mt-4">
                                <h3 class="text-lg font-medium leading-6 text-xs-dark">Dropoff</h3>
                            </div>
                            <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                                <div
                                    class="sm:col-span-6 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg">
                                    <div class="grid grid-cols-1 gap-2 sm:grid-cols-6">
                                        <div class="col-span-full grid grid-cols-1 gap-2 sm:grid-cols-6">

                                            <div class="sm:col-span-3">
                                                <label
                                                    class="block text-sm font-medium text-main-secondary">Time</label>
                                                <div class="mt-1 relative">
                                                    <input type="text" name="dropoffTime" id="dropoffTime"
                                                        formControlName="time" [owlDateTime]="dtDropOffTime"
                                                        [min]="relationlegForm.get('pickup.time')?.value"
                                                        [owlDateTimeTrigger]="dtDropOffTime" />
                                                    <div
                                                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            class="h-5 w-5 text-xs-light" viewBox="0 0 24 24">
                                                            <g fill="none" stroke="currentColor" stroke-linecap="round"
                                                                stroke-linejoin="round" stroke-width="2">
                                                                <path
                                                                    d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                                                                <path
                                                                    d="M14 18a4 4 0 1 0 8 0a4 4 0 1 0-8 0m1-15v4M7 3v4m-4 4h16" />
                                                                <path d="M18 16.496V18l1 1" />
                                                            </g>
                                                        </svg>
                                                    </div>
                                                </div>
                                                <owl-date-time #dtDropOffTime></owl-date-time>
                                            </div>

                                            <div class="sm:col-span-3" formGroupName="address">
                                                <label
                                                    class="block text-sm font-medium text-main-secondary">Address</label>
                                                <div class="mt-1">
                                                    <input type="text" formControlName="name" class="dark:bg-white/5" placeholder="Enter the address" googlePlace
                                                        (onSelect)="setDropoffAddress($event)" (input)="onChangeDropoffAddress()" />
                                                </div>
                                                <div class="error" *ngIf="submitted">
                                                    <p *ngIf="relationlegForm.get('destination.address.name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                                        Address is required
                                                    </p>
                                                    <p *ngIf="relationlegForm.get('destination.address')?.errors?.invalidAddress" class="mt-2 text-red-600 text-xs">
                                                        Invalid address (select from the dropdown)
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pt-6 flex justify-end gap-2">
                            <button type="submit" class="btn btn-secondary">Create</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>